'use client';

import dynamic from 'next/dynamic';
import { isEnterpriseDistribution } from '@/app/constants';

const ReferenceModal = dynamic(() => import('@/app/components/shared/ReferenceModal').then((m) => m.ReferenceModal), {
  loading: () => null,
  ssr: false,
});

const NotificationDialog = dynamic(
  () => import('@/app/components/shared/NotificationDialog').then((m) => m.NotificationDialog),
  { loading: () => null, ssr: false },
);

const WorkspaceRouteFloatingButtons = dynamic(
  () => import('./_components/WorkspaceRouteFloatingButtons').then((m) => m.WorkspaceRouteFloatingButtons),
  { loading: () => null, ssr: false },
);

const WorkspaceAuthGuard = dynamic(() => import('./_components/WorkspaceAuthGuard').then((m) => m.WorkspaceAuthGuard), {
  loading: () => null,
  ssr: false,
});

const WorkspaceGoogleOneTap = dynamic(
  () => import('./_components/WorkspaceGoogleOneTap').then((m) => m.WorkspaceGoogleOneTap),
  { loading: () => null, ssr: false },
);

export function WorkspaceOverlaySlots() {
  return (
    <>
      <ReferenceModal />
      {!isEnterpriseDistribution && (
        <>
          <NotificationDialog />
          <WorkspaceRouteFloatingButtons />
          <WorkspaceGoogleOneTap />
        </>
      )}
      <WorkspaceAuthGuard />
    </>
  );
}
